// extracted by mini-css-extract-plugin
export var rightPart = "connected-module--rightPart--rX5qM";
export var profilePicture = "connected-module--profilePicture--MBw1a";
export var profileDropdown = "connected-module--profileDropdown--TP4Z0";
export var itemProfile = "connected-module--itemProfile--WmQ3s";
export var linkItem = "connected-module--linkItem--iajDu";
export var text = "connected-module--text--ddonn";
export var dropdown = "connected-module--dropdown--TYFXc";
export var buttonLogout = "connected-module--buttonLogout--BOhGE";